import React, { useState } from 'react'
import TeamGoals from '../../pages/performance-management/goals/TeamGoals'
import CompanyGoals from '../../pages/performance-management/goals/CompanyGoals'
import SubTabView from '../tabview-sub'

const Goals = () => {
  const [activeTab, setActiveTab] = useState(0)

  const goalsTab = [
    {
      title: 'Company Goals',
      Content: CompanyGoals,
    },
    {
      title: 'Team Goals',
      Content: TeamGoals,
    },
  ]
  return (
    <div className='flex flex-col w-full'>
      <div>
        <SubTabView
          Tabs={goalsTab}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </div>
  )
}

export default Goals
